export enum RouteIdEnum {
  Root = "",
  Any = "*",
  id = ":id",
  Add = "add",
  Edit = "edit",
  Home = "home",
  Login = "login",
  FORGOT_PASSWORD = "/forgot-password",
  Clients = "clients",
  ClientsPRO = "clients-pro",
  SubscriptionsManagement = "gestion-abonnements",
  ZonePro = "zone-pro",
  PromotionCodes = "promotion_codes",
  Categories = "categories",
  Products = "products",
  Stock = "gestion-stock",
  Arrivage = "arrivage",
  Transfer = "transfer",
  Roles = "roles",
  POS = "pos",
  Vendeurs = "utilisateurs",
  stockPlus = "stockPlus",
  OrderHistory = "order-history",
  Supplier = "supplier",
  SubCategory = "subcategories/:id",
  Delivery = "delivery",
  Expedition_Categories = "expedition-categories",
  Expedition_Mode = "expedition-mode",
  Tax = "taxes",
  Promo_Flash = "promo_flash",
  Dashboard = "dashboard",
  Brand = "brand",
  Stats_Visit = "stats-visit",
  Advanced_Stat = "advanced_stat",
  Opening_Hours = "opening_hours",
  Chat = "chat",
}
